module.exports = __webpack_public_path__ + "quick_practice.svg?04c4680e357ffd94ac026683bba98c7c";


//////////////////
// WEBPACK FOOTER
// ./static/quick_practice.svg
// module id = 41
// module chunks = 0